import { render } from "./PointFocalCreate.vue?vue&type=template&id=a2bc21c8"
import script from "./PointFocalCreate.vue?vue&type=script&lang=js"
export * from "./PointFocalCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__